// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17lKc","buttons":"styles_buttons__1JvnI"};